
































































































































































import ColumnLayout from "./components/ColumnLayout.vue";

import ModuleButtonRegister from "./components/ModuleButtonRegister.vue";

import { Component, Vue, BasePage } from "@/common";

import { TwTable } from "@/components";

import moment from "moment";

@Component({
  components: {
    ColumnLayout,
    ModuleButtonRegister
  }
})
export default class Module extends BasePage {
  editing: boolean = false;

  saveMask: boolean = false;

  isModify: boolean = false;

  pCodeOptions: Array<any> = [];

  layoutShow: boolean = false;

  buttonRegisterShow: boolean = false;

  //是否自定义列布局
  isCustom: boolean = false;

  iconOptions: Array<any> = [
    { value: "el-icon-info" },
    { value: "el-icon-error" },
    { value: "el-icon-success" },
    { value: "el-icon-warning" },
    { value: "el-icon-question" },
    { value: "el-icon-back" },
    { value: "el-icon-arrow-left" },
    { value: "el-icon-arrow-down" },
    { value: "el-icon-arrow-right" },
    { value: "el-icon-arrow-up" },
    { value: "el-icon-caret-left" },
    { value: "el-icon-caret-bottom" },
    { value: "el-icon-caret-top" },
    { value: "el-icon-caret-right" },
    { value: "el-icon-d-arrow-left" },
    { value: "el-icon-d-arrow-right" },
    { value: "el-icon-minus" },
    { value: "el-icon-plus" },
    { value: "el-icon-remove" },
    { value: "el-icon-circle-plus" },
    { value: "el-icon-remove-outline" },
    { value: "el-icon-circle-plus-outline" },
    { value: "el-icon-close" },
    { value: "el-icon-check" },
    { value: "el-icon-circle-close" },
    { value: "el-icon-circle-check" },
    { value: "el-icon-circle-close-outline" },
    { value: "el-icon-circle-check-outline" },
    { value: "el-icon-zoom-out" },
    { value: "el-icon-zoom-in" },
    { value: "el-icon-d-caret" },
    { value: "el-icon-sort" },
    { value: "el-icon-sort-down" },
    { value: "el-icon-sort-up" },
    { value: "el-icon-tickets" },
    { value: "el-icon-document" },
    { value: "el-icon-goods" },
    { value: "el-icon-sold-out" },
    { value: "el-icon-news" },
    { value: "el-icon-message" },
    { value: "el-icon-date" },
    { value: "el-icon-printer" },
    { value: "el-icon-time" },
    { value: "el-icon-bell" },
    { value: "el-icon-mobile-phone" },
    { value: "el-icon-service" },
    { value: "el-icon-view" },
    { value: "el-icon-menu" },
    { value: "el-icon-more" },
    { value: "el-icon-more-outline" },
    { value: "el-icon-star-on" },
    { value: "el-icon-star-off" },
    { value: "el-icon-location" },
    { value: "el-icon-location-outline" },
    { value: "el-icon-phone" },
    { value: "el-icon-phone-outline" },
    { value: "el-icon-picture" },
    { value: "el-icon-picture-outline" },
    { value: "el-icon-delete" },
    { value: "el-icon-search" },
    { value: "el-icon-edit" },
    { value: "el-icon-edit-outline" },
    { value: "el-icon-rank" },
    { value: "el-icon-refresh" },
    { value: "el-icon-share" },
    { value: "el-icon-setting" },
    { value: "el-icon-upload" },
    { value: "el-icon-upload2" },
    { value: "el-icon-download" },
    { value: "el-icon-loading" }
  ];

  modelData = [];

  layoutCode: string = "";

  layoutName: string = "";

  showLayoutModal(layoutCode, layoutName) {
    this.layoutCode = layoutCode;
    this.layoutName = layoutName;
    if (layoutCode) {
      this.isCustom = false;
    } else {
      this.isCustom = true;
    }
    this.layoutShow = true;
  }

  showButtonRegisterModal(layoutCode, layoutName) {
    this.layoutCode = layoutCode;
    this.layoutName = layoutName;

    this.buttonRegisterShow = true;
  }

  md = {
    ID: null,
    nPID: null,
    cCode: "",
    cTitle: "",
    cRoute: "",
    cPath: "",
    cIcon: "",
    iStatus: 1,
    cModuleCode: "",
    iHasRole: null
  };

  rules = {
    cCode: [
      { required: true, message: "请输入编码", trigger: "blur" },
      { min: 2, max: 15, message: "长度在 2 到 15 个字符之间", trigger: "blur" }
    ],
    cTitle: [
      { required: true, message: "请输入名称", trigger: "blur" },
      { min: 2, max: 15, message: "长度在 2 到 15 个字符之间", trigger: "blur" }
    ],
    cRoute: [{ required: true, message: "请输入路由", trigger: "blur" }],
    nPID: [{ required: true, message: "请选择上级模块", trigger: "blur" }]
  };

  columns = [
    {
      prop: "cCode",
      label: "编码",
      align: "center",
      width: 120,
      attrs: {
        type: "string"
      }
    },
    {
      prop: "cTitle",
      label: "名称",
      align: "center",
      width: 120,
      attrs: {
        type: "string"
      }
    },
    {
      prop: "cRoute",
      label: "路由地址",
      align: "center",
      width: 180,
      attrs: {
        type: "string"
      }
    },
    {
      prop: "cPath",
      label: "文件地址",
      align: "center",
      width: 180,
      attrs: {
        type: "string"
      }
    },
    {
      prop: "cIcon",
      label: "图标",
      align: "center",
      width: 100,
      attrs: {
        type: "string"
      },
      render: this.renderIcon
    },
    {
      prop: "iStatus",
      label: "状态",
      align: "center",
      width: 100,
      attrs: {
        type: "string"
      },
      render: this.renderEnabled
    },
    {
      label: "操作",
      align: "center",
      width: 140,
      render: this.renderOperation
    }
  ];

  get table(): TwTable {
    return this.$refs["mdtable"] as TwTable;
  }

  add() {
    this.isModify = false;
    this.editing = true;
    this.resetForm("mdForm");
    // 因为ID未在form表单绑定输入元素,所以resetForm不会重置ID,如果后台需要根据ID做一些判断,可以在这里手动置空
    this.md.ID = null;
    this.md.nPID = this.nSelectPID;
    this.initPCode(0);
  }

  modify() {
    this.isModify = true;
    this.editing = true;
    this.resetForm("mdForm");
    this.loadForm(this.md, this.table.getCurrentRow());
    this.initPCode(this.md.ID);
  }

  save() {
    this.isFormValid("mdForm", valid => {
      if (valid) {
        this.saveMask = true;
        this.$http
          .post("Base/Module/Save", { md: this.md })
          .then(res => {
            if (res.data.status === 0) {
              this.saveMask = false;
              this.editing = false;
              this.$message.success("操作成功");
              this.table.reload();
            } else {
              this.saveMask = false;
              this.$message.warning(res.data.msg || "操作失败");
            }
          })
          .catch(err => {
            this.$message.warning(err);
          });
      }
    });
  }

  deleteRows() {
    this.$http
      .post("Base/Module/Delete", {
        delIds: this.table.getSelections().map(item => item.ID)
      })
      .then(res => {
        if (res.data.status === 0) {
          this.$message.success("删除成功");
          this.table.reload();
        } else {
          this.$message.warning(res.data.msg || "操作失败");
        }
      });
  }

  load() {
    this.table.load();
  }

  currentChange(nodeArray) {
    this.table.load({ ID: nodeArray.id });
    this.nSelectPID=nodeArray.id;
  }

  nSelectPID=null;

  onDrop(e) {
    this.$http
      .post("Base/Module/SortModule", {
        current: e.current,
        target: e.target,
        type: e.type
      })
      .then(res => {
        this.modelData.splice(0);
        this.modelData.push(...res.data);
      });
  }

  mounted() {
    this.$http.get("Base/Module/GetParent").then(res => {
      this.modelData.splice(0);
      this.modelData.push(...res.data);
    });
  }

  initPCode(ID) {
    this.$http.get("Base/Module/GetPCode", { params: { ID } }).then(res => {
      //if (res.data.status === 0) {
      this.pCodeOptions = res.data.data;
      //}
    });
  }

  // 列渲染  使用jsx方式渲染 必须使用函数方式实现 不支持箭头函数和function函数
  renderEnabled(props) {
    switch (props.row.iStatus) {
      case 0:
        return <span style="color:red">停用</span>;
      case 1:
        return <span style="color:green">启用</span>;
    }
  }

  renderIcon(props) {
    return <i class={props.row.cIcon} />;
  }

  // 通过列渲染方式实现之定义列
  renderOperation(props) {
    return (
      <div style="display:inline;">
        <el-tooltip
          content={props.row.iStatus === 1 ? "停用模块" : "启用模块"}
          hide-after={1000}
          placement="bottom"
        >
          <el-button
            style="padding:7px;"
            type={props.row.iStatus === 1 ? "danger" : "success"}
            v-show={props.row.iStatus !== 2}
            onClick={() => {
              props.row._showPop = 0;
              props.row.iStatus = props.row.iStatus === 1 ? 0 : 1;
              this.$http.post("Base/Module/AlterStatus", {
                iStatus: props.row.iStatus,
                ID: props.row.ID
              });
            }}
          >
            {props.row.iStatus === 1 ? "停" : "启"}
          </el-button>
        </el-tooltip>

        <el-tooltip content="列设置" hide-after={1000} placement="bottom">
          <el-button
            style="padding:7px;"
            type="success"
            icon="el-icon-menu"
            onClick={() => {
              this.showLayoutModal(props.row.cCode, props.row.cTitle);
            }}
          />
        </el-tooltip>
        <el-tooltip content="按钮设置" hide-after={1000} placement="bottom">
          <el-button
            style="padding:7px;"
            type="success"
            icon="el-icon-menu"
            onClick={() => {
              this.showButtonRegisterModal(props.row.cCode, props.row.cTitle);
            }}
          />
        </el-tooltip>
      </div>
    );
  }
}
